import { render, staticRenderFns } from "./RhFuncionarioUpdate.vue?vue&type=template&id=2057fe0e&"
import script from "./RhFuncionarioUpdate.vue?vue&type=script&lang=js&"
export * from "./RhFuncionarioUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports